var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "func-define" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "func-tabs" }, [
            _c(
              "div",
              {
                staticClass: "pane",
                class: { active: _vm.activeName === "property" },
                on: {
                  click: function ($event) {
                    return _vm.handleClick("property")
                  },
                },
              },
              [_vm._v("属性定义")]
            ),
            _c(
              "div",
              {
                staticClass: "pane",
                class: { active: _vm.activeName === "event" },
                on: {
                  click: function ($event) {
                    return _vm.handleClick("event")
                  },
                },
              },
              [_vm._v("事件定义")]
            ),
            _c(
              "div",
              {
                staticClass: "pane",
                class: { active: _vm.activeName === "action" },
                on: {
                  click: function ($event) {
                    return _vm.handleClick("action")
                  },
                },
              },
              [_vm._v("动作定义")]
            ),
          ]),
          _vm.currentDevelopStatus === 1 || _vm.currentDevelopStatus === "1"
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content:
                      "产品已发布，信息不可修改，如需修改，请返回开发状态",
                    placement: "top",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "disbled" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "add",
                            icon: "el-icon-plus",
                            disabled:
                              _vm.currentDevelopStatus === 1 ||
                              _vm.currentDevelopStatus === "1" ||
                              _vm.rolesCode === "SALE",
                            size: "14",
                          },
                          on: { click: _vm.addFunc },
                        },
                        [_vm._v("\n          添加")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _c(
                "el-button",
                {
                  attrs: {
                    type: "add",
                    icon: "el-icon-plus",
                    disabled: _vm.isSwitchDisabled,
                    size: "14",
                  },
                  on: { click: _vm.addFunc },
                },
                [_vm._v("添加")]
              ),
        ],
        1
      ),
      _c("physicalModelTable", {
        ref: "modelRef",
        attrs: { "active-name": _vm.activeName },
        on: { "custom-event": _vm.handleEvent },
      }),
      _c("addDialog", {
        ref: "addDialog",
        attrs: { "active-name": _vm.activeName },
      }),
      _c("viewProperties", { ref: "propertiesDialog" }),
      _c("div", { staticClass: "advanced" }, [_vm._v("高级功能")]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.advancedLoading,
              expression: "advancedLoading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            data: _vm.advancedTableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "功能名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.name || "-") + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "chargeType", label: "收费方式" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.chargeType ? "收费" : "免费" || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "功能描述" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.description || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        disabled: _vm.isSwitchDisabled,
                        "active-color": "#275FE8",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleSwitch(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enabled,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enabled", $$v)
                        },
                        expression: "scope.row.enabled",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }